"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmptyDashboardError = void 0;
var tslib_1 = require("tslib");
// (C) 2020-2022 GoodData Corporation
var react_1 = tslib_1.__importDefault(require("react"));
var react_intl_1 = require("react-intl");
var dashboardContexts_1 = require("../dashboardContexts");
exports.EmptyDashboardError = function () {
    var intl = react_intl_1.useIntl();
    var ErrorComponent = dashboardContexts_1.useDashboardComponentsContext().ErrorComponent;
    return (react_1.default.createElement(ErrorComponent, { className: "s-layout-error", message: intl.formatMessage({ id: "dashboard.error.empty.heading" }), description: intl.formatMessage({ id: "dashboard.error.empty.text" }) }));
};
//# sourceMappingURL=EmptyDashboardError.js.map